import { combineReducers } from 'redux';

/*import events from './events';
import tasks from './tasks';*/
import notifications from './notifications';

export default combineReducers({
  /*events, tasks,*/ notifications
});